import { COMMANDERS, Treasure as TreasureType } from '../../../../c.managers/LevelManager/store.d'
import { useSceneStore } from '../../../../a.scenes/GameScene/store'
import { Terrain } from '../../../../d.controllers/TerrainController'
import Treasure from '../../../GameElements/classes/Treasure'

const getEnemyTreasure = (myCommander: COMMANDERS): Treasure => {
  const treasureStates = useSceneStore.getState().terrain.data.treasures
  const booty = treasureStates.find(l => l.owner !== myCommander) as TreasureType

  return Terrain.getElementAt(booty.coords) as Treasure
}

export default getEnemyTreasure
